const choices = {
    none: 'Aucun',
    deduction: 'Déduction',
    reduction: 'Réduction',
};

export default choices;
